import IcoRoundClock01 from './clock.svg.js';
import IcoRoundArrow01 from './round_arrow01.svg.js';
import IcoRoundArrow02 from './round_arrow02.svg.js';
import IcoRoundArrow03 from './round_arrow03.svg.js';
import IcoRoundCheck from './round_check.svg.js';
import IcoRoundClock02 from './round_clock02.svg.js';
import IcoRoundClock03 from './round_clock03.svg.js';
import IcoRoundReject from './round_reject.svg.js';
import CCFeeWaiver from './cc_fee_waiver.svg.js';
import CreditBalanceRefund from './credit_balance_refund.svg.js';
import CurrencyCircleDollarArrow from './currency_circle_dollar_arrow.svg.js';
import CurrencyCircleDollarArrowDownLeft from './currency_circle_dollar_arrow_down_left.svg.js';
import CurrencyCircleDollarArrowLeft from './currency_circle_dollar_arrow_left.svg.js';
import CurrencyCircleDollarArrowRight from './currency_circle_dollar_arrow_right.svg.js';
import CurrencyCircleDollarArrowUpRight from './currency_circle_dollar_arrow_up_right.svg.js';
import GrowWealthUS from './grow_wealth_us.svg.js';
import UpYourWealthGame from './up_your_wealth_game.svg.js';
import UpYourWealthGame02 from './up_your_wealth_game02.svg.js';
import PayfromAccount from './payfrom_account.svg.js';
import FaceID from './face_id.svg.js';
import IdCard from './id_card.svg.js';
import PinCode3 from './pin_code3.svg.js';
import PinCode from './PinCode.svg.js';
import SimpleAuthentication from './simple_authentication.svg.js';
import IcoTooltip from './tooltip.svg.js';
import IcoCaretDownXs from './caret_down_xs.svg.js';
import IcoCheck from './check.svg.js';
import CircleChevronRight from './circle_chevron_right.svg.js';
import CirCleLock from './circle_lock.svg.js';
import Equity from './Equity.svg.js';
import IcoGlobe from './globe.svg.js';
import Identityconfirm from './identity_confirm.svg.js';
import InFrame from './in_frame.svg.js';
import InFrameEye from './in_frame_eye.svg.js';
import Lock from './lock.svg.js';
import LockKey from './lock_key.svg.js';
import IcoMobile from './mobile.svg.js';
import MoneyWaveCurrency from './money_wave_currency.svg.js';
import OnlineBanking2 from './online_banking2.svg.js';
import Pencil from './pencil.svg.js';
import PersonalLliability from './personal_liability.svg.js';
import RectangleDown from './rectangle_down.svg.js';
import RectangleUp from './rectangle_up.svg.js';
import Remit from './Remit.svg.js';
import SecurityDocument from './security_document.svg.js';
import Share from './share01.svg.js';
import Bell from './bell.svg.js';
import IcoCoins from './coins2.svg.js';
import Database from './database.svg.js';
import IcoDigitalOtp from './digital_otp.svg.js';
import MobileWallet from './mobile_wallet.svg.js';
import Placeholder from './placeholder.svg.js';
import Shield from './shield.svg.js';
import ShieldCheck from './shield_check.svg.js';
import IcoMobileWallet from './top_up_mobile_wallet.svg.js';
import Toss from './toss.svg.js';
import TossColor from './toss_color.svg.js';
import TossColor64 from './toss_color_64.svg.js';
import TradingPlatform from './trading_platform.svg.js';
import Transformation from './transformation.svg.js';
import Trash from './trash.svg.js';
import IcoVisaTransfer from './visa_transfer.svg.js';
import Bell2 from './bell2.svg.js';
import Gift from './gift.svg.js';
import Growth2 from './growth2.svg.js';
import LocalTransfer from './local_transfer.svg.js';
import Rewards from './rewards.svg.js';
import SavingsAccount from './savings_account.svg.js';
import TimeDeposit from './time_deposit.svg.js';
import Cyber from './cyber.svg.js';
import SignatureSelect from './signature_select.svg.js';
import WarningCircle from './warning_circle_xl2.svg.js';
import Close from './close.svg.js';
import CloseWhite from './close_w.svg.js';
import CaretSmall from './caret-s.svg.js';
import Pause from './pause.svg.js';
import Play from './play.svg.js';
import { common } from '../../../js/common.js';
import NavDeposite from './icon_menu_01.svg.js';

const Logo = common.asset("ui/images/sc_logo.png");
const LogoWhite = common.asset("ui/images/sc_logo_white.png");
const IconBank01 = common.asset("ui/images/banking/icon_bank_01.png");
const IconBank02 = common.asset("ui/images/banking/icon_bank_02.png");
const IconBank03 = common.asset("ui/images/banking/icon_bank_03.png");
const ImgCertificate1 = common.asset("ui/images/common/img_certificate1.png");
const ImgCertificate2 = common.asset("ui/images/common/img_certificate2.png");
const ImgFinanceGuide101 = common.asset("ui/images/common/finance/guide1-1.png");
const ImgFinanceGuide102 = common.asset("ui/images/common/finance/guide1-2.png");
const ImgFinanceGuide103 = common.asset("ui/images/common/finance/guide1-3.png");
const ImgFinanceGuide104 = common.asset("ui/images/common/finance/guide1-4.png");
const ImgFinanceGuide201 = common.asset("ui/images/common/finance/guide2-1.png");
const ImgFinanceGuide202 = common.asset("ui/images/common/finance/guide2-2.png");
const ImgFinanceGuide203 = common.asset("ui/images/common/finance/guide2-3.png");
const ImgFinanceGuide204 = common.asset("ui/images/common/finance/guide2-4.png");
const ImgFinanceGuide301 = common.asset("ui/images/common/finance/guide3-1.png");
const ImgFinanceGuide302 = common.asset("ui/images/common/finance/guide3-2.png");
const ImgFinanceGuide401 = common.asset("ui/images/common/finance/guide4-1.png");
const ImgFinanceGuide402 = common.asset("ui/images/common/finance/guide4-2.png");
const ImgFinanceGuide403 = common.asset("ui/images/common/finance/guide4-3.png");
const ImgFinanceGuide404 = common.asset("ui/images/common/finance/guide4-4.png");
const ImgFinanceGuide501 = common.asset("ui/images/common/finance/guide5-1.png");
const ImgFinanceGuide502 = common.asset("ui/images/common/finance/guide5-2.png");
const ImgFinanceGuide503 = common.asset("ui/images/common/finance/guide5-3.png");
const ImgCertificationPoint1 = common.asset(
  "ui/images/common/certification/certification_point1.png"
);
const ImgCertificationPoint2 = common.asset(
  "ui/images/common/certification/certification_point2.png"
);
const ImgCertificationPoint3 = common.asset(
  "ui/images/common/certification/certification_point3.png"
);
const ImgCertificationPoint4 = common.asset(
  "ui/images/common/certification/certification_point4.png"
);
const ImgCertificationGuide101 = common.asset("ui/images/common/certification/guide1-1.png");
const ImgCertificationGuide102 = common.asset("ui/images/common/certification/guide1-2.png");
const ImgCertificationGuide103 = common.asset("ui/images/common/certification/guide1-3.png");
const ImgCertificationGuide104 = common.asset("ui/images/common/certification/guide1-4.png");
const ImgCertificationGuide105 = common.asset("ui/images/common/certification/guide1-5.png");
const ImgCertificationGuide106 = common.asset("ui/images/common/certification/guide1-6.png");
const ImgCertificationGuide201 = common.asset("ui/images/common/certification/guide2-1.png");
const ImgCertificationGuide202 = common.asset("ui/images/common/certification/guide2-2.png");
const ImgCertificationGuide203 = common.asset("ui/images/common/certification/guide2-3.png");
const ImgCertificationGuide204 = common.asset("ui/images/common/certification/guide2-4.png");
const ImgCertificationGuide205 = common.asset("ui/images/common/certification/guide2-5.png");
const ImgCertificationGuide301 = common.asset("ui/images/common/certification/guide3-1.png");
const ImgCertificationGuide302 = common.asset("ui/images/common/certification/guide3-2.png");
const ImgCertificationGuide303 = common.asset("ui/images/common/certification/guide3-3.png");
const ImgCertificationGuide304 = common.asset("ui/images/common/certification/guide3-4.png");
const ImgCertificationGuide305 = common.asset("ui/images/common/certification/guide3-5.png");
const ImgCertificationGuide401 = common.asset("ui/images/common/certification/guide4-1.png");
const ImgCertificationGuide402 = common.asset("ui/images/common/certification/guide4-2.png");
const ImgCertificationGuide403 = common.asset("ui/images/common/certification/guide4-3.png");
const ImgCertificationGuide404 = common.asset("ui/images/common/certification/guide4-4.png");
const ImgCertificationGuide501 = common.asset("ui/images/common/certification/guide5-1.png");
const ImgCertificationGuide502 = common.asset("ui/images/common/certification/guide5-2.png");
const ImgCertificationGuide503 = common.asset("ui/images/common/certification/guide5-3.png");
const ImgCertificationGuide504 = common.asset("ui/images/common/certification/guide5-4.png");
const ImgCertificationGuide505 = common.asset("ui/images/common/certification/guide5-5.png");
const ImgCertificationGuide506 = common.asset("ui/images/common/certification/guide5-6.png");
const ImgCertificationGuide601 = common.asset("ui/images/common/certification/guide6-1.png");
const ImgCertificationGuide602 = common.asset("ui/images/common/certification/guide6-2.png");
const ImgCertificationGuide603 = common.asset("ui/images/common/certification/guide6-3.png");
const ImgCertificationGuide604 = common.asset("ui/images/common/certification/guide6-4.png");
const ImgCertificationGuide605 = common.asset("ui/images/common/certification/guide6-5.png");
const CertificationSample = common.asset("ui/images/common/certification_sample.png");
const ImgCollectionImg = common.asset("ui/images/common/collection_img.png");
const Empty = common.asset("ui/images/common/empty.png");
const Ubikey = common.asset("ui/images/ubikey.png");
const ImgFlagAED = common.asset("ui/images/common/flag_aed.svg");
const ImgFlagAUD = common.asset("ui/images/common/flag_aud.svg");
const ImgFlagBHD = common.asset("ui/images/common/flag_bhd.svg");
const ImgFlagCAD = common.asset("ui/images/common/flag_cad.svg");
const ImgFlagCHF = common.asset("ui/images/common/flag_chf.svg");
const ImgFlagCNY = common.asset("ui/images/common/flag_cny.svg");
const ImgFlagDKK = common.asset("ui/images/common/flag_dkk.svg");
const ImgFlagEUR = common.asset("ui/images/common/flag_eur.svg");
const ImgFlagGBP = common.asset("ui/images/common/flag_gbp.svg");
const ImgFlagHKD = common.asset("ui/images/common/flag_hkd.svg");
const ImgFlagIDR = common.asset("ui/images/common/flag_idr.svg");
const ImgFlagJPY = common.asset("ui/images/common/flag_jpy.svg");
const ImgFlagKRW = common.asset("ui/images/common/flag_krw.svg");
const ImgFlagKWD = common.asset("ui/images/common/flag_kwd.svg");
const ImgFlagMYR = common.asset("ui/images/common/flag_myr.svg");
const ImgFlagNOK = common.asset("ui/images/common/flag_nok.svg");
const ImgFlagNZD = common.asset("ui/images/common/flag_nzd.svg");
const ImgFlagSAR = common.asset("ui/images/common/flag_sar.svg");
const ImgFlagSEK = common.asset("ui/images/common/flag_sek.svg");
const ImgFlagSGD = common.asset("ui/images/common/flag_sgd.svg");
const ImgFlagTHB = common.asset("ui/images/common/flag_thb.svg");
const ImgFlagUSD = common.asset("ui/images/common/flag_usd.svg");
const ImgFlagAEDsquare = common.asset("ui/images/common/flag_aed_square.svg");
const ImgFlagAUDsquare = common.asset("ui/images/common/flag_aud_square.svg");
const ImgFlagBHDsquare = common.asset("ui/images/common/flag_bhd_square.svg");
const ImgFlagCADsquare = common.asset("ui/images/common/flag_cad_square.svg");
const ImgFlagCHFsquare = common.asset("ui/images/common/flag_chf_square.svg");
const ImgFlagCNYsquare = common.asset("ui/images/common/flag_cny_square.svg");
const ImgFlagDKKsquare = common.asset("ui/images/common/flag_dkk_square.svg");
const ImgFlagEURsquare = common.asset("ui/images/common/flag_eur_square.svg");
const ImgFlagGBPsquare = common.asset("ui/images/common/flag_gbp_square.svg");
const ImgFlagHKDsquare = common.asset("ui/images/common/flag_hkd_square.svg");
const ImgFlagIDRsquare = common.asset("ui/images/common/flag_idr_square.svg");
const ImgFlagJPYsquare = common.asset("ui/images/common/flag_jpy_square.svg");
const ImgFlagKRWsquare = common.asset("ui/images/common/flag_krw_square.svg");
const ImgFlagKWDsquare = common.asset("ui/images/common/flag_kwd_square.svg");
const ImgFlagMYRsquare = common.asset("ui/images/common/flag_myr_square.svg");
const ImgFlagNOKsquare = common.asset("ui/images/common/flag_nok_square.svg");
const ImgFlagNZDsquare = common.asset("ui/images/common/flag_nzd_square.svg");
const ImgFlagSARsquare = common.asset("ui/images/common/flag_sar_square.svg");
const ImgFlagSEKsquare = common.asset("ui/images/common/flag_sek_square.svg");
const ImgFlagSGDsquare = common.asset("ui/images/common/flag_sgd_square.svg");
const ImgFlagTHBsquare = common.asset("ui/images/common/flag_thb_square.svg");
const ImgFlagUSDsquare = common.asset("ui/images/common/flag_usd_square.svg");
const ImgFooterBanner = common.asset("ui/images/common/footer_banner.png");
const ImgBankStamp = common.asset("ui/images/common/img_bankbook_stamp.png");
const ImgKdic = common.asset("ui/images/common/img_kdic.png");
const ImgSMS = common.asset("ui/images/common/img_sms.png");
const ImgWa = common.asset("ui/images/common/wa.png");
const ImgProtectionNotice = common.asset("ui/images/img_protection_notice.png");
const ImgProtectionNone = common.asset("ui/images/img_protection_none.png");
const ImgUnprotected = common.asset("ui/images/img_unprotected.png");
const ImgKgzeroin = common.asset("ui/images/kgzeroin.png");
const ImgCustCenterCheck = common.asset("ui/images/common/img_custcenter_check.png");
const PhoneFrame = common.asset("ui/images/common/easy_phoneframe.jpg");
const PhoneFrame01 = common.asset("ui/images/common/easy_phoneframe01.png");
const PhoneFrame02 = common.asset("ui/images/common/easy_phoneframe02.png");
const ImgLogoKT = common.asset("ui/images/common/ci_kt.png");
const ImgLogoSK = common.asset("ui/images/common/ci_sk.png");
const ImgLogoUplus = common.asset("ui/images/common/ci_uplus.png");
const ImgQR = common.asset("ui/images/common/img_qr.png");
const ImgQRCDD = common.asset("ui/images/common/CDDQRimg.jpg");
const Images = {
  Logo,
  LogoWhite,
  Empty,
  IconBank01,
  IconBank02,
  IconBank03,
  IcoCoins,
  IcoRoundArrow01,
  IcoRoundArrow02,
  IcoRoundArrow03,
  IcoRoundCheck,
  IcoRoundClock01,
  IcoRoundClock02,
  IcoRoundClock03,
  IcoRoundReject,
  IcoDigitalOtp,
  IcoVisaTransfer,
  IcoMobileWallet,
  MobileWallet,
  CCFeeWaiver,
  CreditBalanceRefund,
  CurrencyCircleDollarArrowRight,
  GrowWealthUS,
  UpYourWealthGame,
  UpYourWealthGame02,
  CurrencyCircleDollarArrow,
  CurrencyCircleDollarArrowLeft,
  CurrencyCircleDollarArrowUpRight,
  CurrencyCircleDollarArrowDownLeft,
  PayfromAccount,
  FaceID,
  SimpleAuthentication,
  Toss,
  Trash,
  IdCard,
  //ADO 빌드 오류 수정 icon.svg 파일이 없음
  //Icon,
  IcoTooltip,
  CircleChevronRight,
  Equity,
  IcoCaretDownXs,
  IcoCheck,
  IcoGlobe,
  CirCleLock,
  Identityconfirm,
  OnlineBanking2,
  InFrameEye,
  InFrame,
  LockKey,
  Lock,
  IcoMobile,
  MoneyWaveCurrency,
  Pencil,
  PersonalLliability,
  PinCode,
  PinCode3,
  RectangleDown,
  RectangleUp,
  Remit,
  SecurityDocument,
  Share,
  ShieldCheck,
  Shield,
  ImgKdic,
  ImgFooterBanner,
  ImgWa,
  ImgBankStamp,
  TossColor,
  TossColor64,
  ImgCertificationGuide101,
  ImgCertificationGuide102,
  ImgCertificationGuide103,
  ImgCertificationGuide104,
  ImgCertificationGuide105,
  ImgCertificationGuide106,
  ImgCertificationGuide201,
  ImgCertificationGuide202,
  ImgCertificationGuide203,
  ImgCertificationGuide204,
  ImgCertificationGuide205,
  ImgCertificationGuide301,
  ImgCertificationGuide302,
  ImgCertificationGuide303,
  ImgCertificationGuide304,
  ImgCertificationGuide305,
  ImgCertificationGuide401,
  ImgCertificationGuide402,
  ImgCertificationGuide403,
  ImgCertificationGuide404,
  ImgCertificationGuide501,
  ImgCertificationGuide502,
  ImgCertificationGuide503,
  ImgCertificationGuide504,
  ImgCertificationGuide505,
  ImgCertificationGuide506,
  ImgCertificationGuide601,
  ImgCertificationGuide602,
  ImgCertificationGuide603,
  ImgCertificationGuide604,
  ImgCertificationGuide605,
  CertificationSample,
  ImgFinanceGuide101,
  ImgFinanceGuide102,
  ImgFinanceGuide103,
  ImgFinanceGuide104,
  ImgFinanceGuide201,
  ImgFinanceGuide202,
  ImgFinanceGuide203,
  ImgFinanceGuide204,
  ImgFinanceGuide301,
  ImgFinanceGuide302,
  ImgFinanceGuide401,
  ImgFinanceGuide402,
  ImgFinanceGuide403,
  ImgFinanceGuide404,
  ImgFinanceGuide501,
  ImgFinanceGuide502,
  ImgFinanceGuide503,
  ImgCertificate1,
  ImgCertificate2,
  ImgCertificationPoint1,
  ImgCertificationPoint2,
  ImgCertificationPoint3,
  ImgCertificationPoint4,
  ImgSMS,
  ImgKgzeroin,
  ImgCustCenterCheck,
  ImgProtectionNotice,
  ImgProtectionNone,
  ImgUnprotected,
  ImgFlagKRW,
  ImgFlagDKK,
  ImgFlagAUD,
  ImgFlagSEK,
  ImgFlagHKD,
  ImgFlagCHF,
  ImgFlagCAD,
  ImgFlagGBP,
  ImgFlagEUR,
  ImgFlagJPY,
  ImgFlagUSD,
  ImgFlagNOK,
  ImgFlagSAR,
  ImgFlagKWD,
  ImgFlagBHD,
  ImgFlagAED,
  ImgFlagSGD,
  ImgFlagMYR,
  ImgFlagNZD,
  ImgFlagCNY,
  ImgFlagIDR,
  ImgFlagTHB,
  ImgFlagKRWsquare,
  ImgFlagDKKsquare,
  ImgFlagAUDsquare,
  ImgFlagSEKsquare,
  ImgFlagHKDsquare,
  ImgFlagCHFsquare,
  ImgFlagCADsquare,
  ImgFlagGBPsquare,
  ImgFlagEURsquare,
  ImgFlagJPYsquare,
  ImgFlagUSDsquare,
  ImgFlagNOKsquare,
  ImgFlagSARsquare,
  ImgFlagKWDsquare,
  ImgFlagBHDsquare,
  ImgFlagAEDsquare,
  ImgFlagSGDsquare,
  ImgFlagMYRsquare,
  ImgFlagNZDsquare,
  ImgFlagCNYsquare,
  ImgFlagIDRsquare,
  ImgFlagTHBsquare,
  ImgQR,
  ImgQRCDD,
  Transformation,
  ImgCollectionImg,
  TradingPlatform,
  ImgLogoKT,
  ImgLogoSK,
  ImgLogoUplus,
  Bell,
  NavDeposite,
  Placeholder,
  Database,
  Bell2,
  Gift,
  Rewards,
  Growth2,
  SavingsAccount,
  LocalTransfer,
  TimeDeposit,
  PhoneFrame,
  PhoneFrame01,
  PhoneFrame02,
  SignatureSelect,
  Cyber,
  WarningCircle,
  Close,
  CloseWhite,
  Ubikey,
  Play,
  Pause,
  CaretSmall
};
Object.keys(Images).map((name) => ({
  name,
  src: Images[name]
}));

export { Images };
